import AllProducts from "./components/AllProducts";
import Banner from "./components/Banner";
import Box from "./components/Box";
import CategoryListBg from "./components/CategoryListBg";
import Cod from "./components/Cod";
import Header from "./components/header/Header";
import NewCustomer from "./components/NewCustomer";
import Trend from "./components/Trend";

function App() {
  return (
    <div className="App">
      <Header />
      <main className="lg:max-w-6xl mx-auto">
        <Banner />
        <Box />
        <NewCustomer />
        <Trend />
        <Cod />
        <CategoryListBg />
        <AllProducts />
        <div className="my-8 w-full text-center">
          <button className="w-80 h-12 px-4 py-2 border border-tokped_green rounded-md text-tokped_green hover:text-green-500 font-bold text-lg">
            Muat Lebih Banyak
          </button>
        </div>
      </main>
    </div>
  );
}

export default App;
